import { render, staticRenderFns } from "./stage-card.vue?vue&type=template&id=172680fa&scoped=true&"
import script from "./stage-card.js?vue&type=script&lang=js&"
export * from "./stage-card.js?vue&type=script&lang=js&"
import style0 from "./stage-card.vue?vue&type=style&index=0&id=172680fa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "172680fa",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
installComponents(component, {VCard,VCardText,VCardTitle})
